import { useCallback, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { isUserLoggedIn, logoutUser } from "./auth-utils";
import { useHistory } from 'react-router-dom';

let lastInteraction;
let intervalId;

/**
 * @name IdleSessionTimeoutModal
 * @author Ryan Gambrell
 * 
 * Purpose: Monitors a user's login session
 * and provides an automatic logout mechanism
 * for idle user sessions. 
 */
export default function IdleSessionTimeoutModal({ logOutAfterSeconds }) {
    const [showModal, setShowModal] = useState(false);
    const history = useHistory();
    const interactiveUserEvents = ['click', 'scroll', 'keydown', 'mousemove'];
    const onInteraction = useCallback(() => {
        lastInteraction = new Date();
        setShowModal(false);
    }, [setShowModal]);

    function checkIdle() {
        if (!isUserLoggedIn()) {
            return;
        }

        const elapsedSeconds = (new Date() - lastInteraction) / 1000;

        if (elapsedSeconds > logOutAfterSeconds) {
            onInteraction();
            history.push(logoutUser() + "?idle");
            setShowModal(false);
        } else if (elapsedSeconds > logOutAfterSeconds - 60) {
            setShowModal(true);
        }
    }

    useEffect(() => {
        interactiveUserEvents.forEach(e => window.addEventListener(e, onInteraction));
        intervalId = setInterval(checkIdle, 1000);

        return () => {
            interactiveUserEvents.forEach(e => window.removeEventListener(e, onInteraction));
            clearInterval(intervalId);
        };
    }, [onInteraction]);

    return (
        <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Are you there?
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    For security reasons, you will be logged out in one minute.
                    Move your mouse or tap anywhere on the screen to stay logged in.
                </p>
            </Modal.Body>
        </Modal>
    );
}
